<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm v-if="showForm" :formSchema="formSchema" :viewPermission="viewPermission" v-on:emitForm="close"></insertForm>

    <v-card-title>
      <h2>Project Employee Information</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.sap_id }}</td>
        <td class="text-xs-left">{{ props.item.employee_name }}</td>
        <td class="text-xs-left">{{ props.item.designation_name }}</td>
        <td class="text-xs-left">{{ props.item.project_designation }}</td>
        <td class="text-xs-left">{{ props.item.organization }}</td>
        <!-- <td class="text-xs-left">{{ props.item.mobile_no }}</td> -->
        <!-- <td class="text-xs-left">{{ props.item.office_phone }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td> -->
        <td class="text-xs-left">{{ changeFormateDMY(props.item.project_join_date) }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.user_name) }}</td>
        <td class="text-xs-left">{{ props.item.rank }}</td>
        
        <td class="text-xs-left">         
          <span v-if="props.item.is_active" class="active">Yes</span>           
          <span v-else class="in-active">No</span>            
        </td> 
        <td class="justify-center layout px-0">

          <v-btn v-if="userRole.updateButton" icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn title="View" v-if="userRole.viewButton && userRole.updateButton<1" icon class="mx-0" @click="editItem(props.index, props.item, 'view')">
            <v-icon color="teal">edit</v-icon>
          </v-btn>

          <v-btn v-if="userRole.deleteButton" icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./insertForm";
import Axios from "axios";

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,

    showForm:false,
    viewPermission:0,

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
          text: "Sap Id", align: "left", sortable: true, value: "sap_id"
        },
        {
          text: "Emp Name", align: "left", sortable: true, value: "employee_name"
        },
        {
          text: "Designation", align: "left", sortable: true, value: "designation_name"
        },
        {
          text: "Project Designation", align: "left", sortable: true, value: "project_designation"
        },
        {
          text: "Organization", align: "left", sortable: true, value: "organization"
        },
        /*
        {
          text: "Mobile No", align: "left", sortable: true, value: "mobile_no"
        },*/
       /* {
          text: "Office Phone", align: "left", sortable: true, value: "office_phone"
        },
        {
          text: "Email", align: "left", sortable: true, value: "email"
        },*/
        {
          text: "Project Join Date", align: "left", sortable: true, value: "project_join_date"
        },
        {
          text: "User Name", align: "left", sortable: true, value: "user_name"
        },
        {
          text: "Rank", align: "left", sortable: true, value: "rank"
        },
        {
          text: "Active", align: "left", sortable: true, value: "is_active"
        },
               
        { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    formSchema: {
      id : 0,
      sap_id: "",
      user_id:0,
      employee_name: "",
      organization: "",
      mobile_no: "",
      office_phone: "",
      ip_phone: "",
      email: "",
      project_join_date: "",
      project_end_date: "",
      rank: "",
      is_active: "",
        
    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    },

    userRole: function(){}
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },

    userRole() {      
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },
  /*------------/Datatable------------*/

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService.getServerSideData(query_Data, "project-staff-info-list").then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item, view='') {     

      this.row_index = index;
      this.formSchema = {...item};

      if(item.project_join_date != '0000-00-00')
      {
      this.formSchema.project_join_date = this.changeFormateDMY(
                      item.project_join_date
              );
      }
      else
      {
        this.formSchema.project_join_date = "";
      }
      if(item.project_end_date != '0000-00-00')
      {
        this.formSchema.project_end_date = this.changeFormateDMY(
                        item.project_end_date
                );
      }
      else
      {
        this.formSchema.project_end_date = "";
      }
      
      if(view)
      {
        this.viewPermission = true;        
      }
      this.showForm = true;

      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "project-staff-info").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.getDataFromApi();
          this.SnackbarVal.color = "success"
        }
        else
        {          
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
      let $this = this;
      let formSchema = this.formSchema;

      if (res.status == 1) {
        if (res.action == "add") {
          this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {          
          this.$set(this.desserts, this.row_index, { ...res.data });
          this.row_index = "";
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
            behavior: "smooth"
        });
        this.SnackbarVal.color = "success"
      }            
      else 
      {
        formSchema.project_join_date = this.changeFormateDMY(
                      formSchema.project_join_date
              );
        formSchema.project_end_date = this.changeFormateDMY(
                      formSchema.project_end_date
              );
        this.SnackbarVal.color = "error"
      }

      this.viewPermission = false;
      this.showForm = this.userRole.saveButton;

      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/project_staff_info/dataTable.vue